export const PICTOGRAM_MAX_BYTES = 2 * 1024 * 1024;

export const pictogramFileError = (file, allowExisting = false) => {
  if (!file) return "Seleziona un'immagine.";
  const allowed = allowExisting ? /\.(svg|png|jpe?g|webp)$/i : /\.(svg|png)$/i;
  if (!allowed.test(file.name)) return "Formato non supportato: usa SVG o PNG.";
  if (file.size > PICTOGRAM_MAX_BYTES) return "Il pittogramma non può superare 2 MB.";
  return null;
};